module.exports = __webpack_public_path__ + "static/img/on-line.bdfb57df.png";